// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3Hhdo","App-logo":"App_App-logo__1Sjr1","App-logo-spin":"App_App-logo-spin__8aGHE","App-header":"App_App-header__1YBIh"};